import client from '/src/services/client.js';
import { env } from "/src/var/env";
export default {

    getChannelsAvailable: (data) => client.get('channels/dashboard/available', data),
    loadBotBlock: async (data, company, bot_id,channel_key) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Talkr-Query' : '1', 'X-Talkr-Analytics-Disable' : '1', "x-talkr-channel-key" :channel_key },
            body: JSON.stringify(data)
        };
        let path = env.REACT_APP_API_PATH.split("/api/v1")[0] + "/";
        let res = await fetch(path + `${company}/bots/${bot_id}/api/web`, requestOptions);
        return res.json();
    },

    // DASHBOARD
    getDashboards: (data) => client.get('dashboards', data),
    getDashboardsShared : (data) => client.get('dashboards/shared', data),
    addDashboard: (data) => client.post(`dashboard`, data),
    updateDashboard: (id, data) => client.put(`dashboard/${id}`, data),
    updateDashboardShared: (id, data) => client.put(`dashboard/shared/${id}`, data),
    deleteDashboard: (id, data) => client.delete(`dashboard/${id}`, data),
    getDashboard: (data) => client.get(`dashboard/info`, data),
    getDashboardChannel: (data) => client.get(`dashboard_channel/info`, data),
    getChannelsAvailableForDashboard :(data) => client.get(`dashboard/channels_availables`, data),
    // BLOCK

    addBlock: (data) => client.post(`dashboard/block`, data),
    addBlockGrid: (data) => client.post(`dashboard/block_grid`, data),
    editBlock: (id, data) => client.put(`dashboard/block/${id}`, data),
    updatePositionBlock : (id, data) => client.put(`dashboard/block/${id}/position`, data),
    editBlockGrid: (id, data) => client.put(`dashboard/block_grid/${id}`, data),
    deleteBlock: (id, data) => client.delete(`dashboard/block/${id}`, data),

    // VARIABLES
    getBotVariableAvailable: (data) => client.get(`dashboard/bot_variables_availables`, data),
    addVariable: (data) => client.post(`dashboard/variable`, data),
    editVariable: (id, data) => client.put(`dashboard/variable/${id}`, data),
    updatePositionVariable : (id, data) => client.put(`dashboard/variable/${id}/position`, data),
    updateDashboardVariableShared: (id, data) => client.put(`dashboard/variable/shared/${id}`, data),
    updateCellValueGrid: (id, data) => client.put(`dashboard/grid/cell/${id}`, data),
    deleteVariable: (id, data) => client.delete(`dashboard/variable/${id}`, data),
}